<template>
  <v-dialog
    transition="dialog-bottom-transition"
    persistent
    lazy
    scrollable
    :value="show"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    :width="$store.state.common.largeDialogWidth"
    @input="(val) => $emit('update:show', val)"
  >
    <v-card>
      <v-card-title class="pb-0">
        <v-layout
          align-center
          justify-center
        >
          <h1 class="headline">
            <v-layout
              align-center
              :column="$vuetify.breakpoint.xs"
            >
              <v-icon
                color="msr"
                :class="{
                  'mr-2': $vuetify.breakpoint.smAndUp,
                  'mb-2': $vuetify.breakpoint.xs,
                }"
              >
                timelapse
              </v-icon>
              {{ $t('createNewTimeframe') }}
            </v-layout>
          </h1>
          <v-btn
            class="ml-auto mr-0 my-0"
            flat
            icon
            :title="$t('abort')"
            @click="onAborted()"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <timeframe-widget
          ref="timeframe-widget"
          class="mt-3"
          :timeframe-start.sync="timeframe.start"
          :timeframe-end.sync="timeframe.end"
          :timeframe-weekdays.sync="timeframe.weekdays"
          :timeframe-name.sync="timeframe.name"
          :timeframe-group-id.sync="timeframe.group.id"
          @submit="formIsValid ? onConfirmed() : null"
        />
      </v-card-text>
      <v-card-actions>
        <v-layout justify-center>
          <btn-ok
            round
            icon="check"
            :disabled="!formIsValid"
            :title="$t('save')"
            data-cy="create-timeframe-dialog-confirm-btn"
            @click="onConfirmed()"
          />
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import dayjs from 'dayjs';

import {deepCopyObject} from '@/utils';

import {ALL_WEEKDAY_INDICES} from '@/mixins/weekdays';
import uploadGroupSelect from '@/mixins/uploadGroupSelect';

import BtnOk from '@/components/ButtonOk';
import TimeframeWidget from '@/components/TimeframeWidget';

const defaults = {
  timeframe: {
    id: null,
    start: '',
    end: '',
    weekdays: ALL_WEEKDAY_INDICES,
    name: '',
    group: {
      id: null,
    },
  },
};

export default {
  components: {
    BtnOk,
    TimeframeWidget,
  },
  mixins: [uploadGroupSelect],
  props: {
    show: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      timeframe: deepCopyObject(defaults.timeframe),
    };
  },
  computed: {
    formIsValid() {
      return (
        !!this.timeframe.name &&
        !!this.timeframe.name.trim() &&
        this.timeframe.group.id &&
        this.timeframe.start &&
        this.timeframe.end &&
        this.timeframe.weekdays.length > 0
      );
    },
  },
  watch: {
    show: function (show) {
      this.reset();

      if (show) {
        this.$nextTick(() => {
          this.$refs['timeframe-widget'].$refs['timeframe-name-input'].focus();
        });
      }
    },
  },
  methods: {
    populateTimeframeWithDefaultValues() {
      this.timeframe.group.id = this.getInitialUploadgroupId();
      this.timeframe.start = this.getInitialTimeframeStart();
      this.timeframe.end = this.getInitialTimeframeEnd();
      this.timeframe.weekdays = this.getInitialTimeframeWeekdays();
    },
    /** Use now and 4h-later as start/end defaults. */
    getInitialTimeframeStart() {
      const now = new dayjs();
      return `${now.hour()}:00}`;
    },
    getInitialTimeframeEnd() {
      const now = new dayjs();
      let endHour = now.hour() + 4;
      if (endHour > 23) {
        endHour = endHour - 23;
      }
      return `${endHour}:00}`;
    },
    getInitialTimeframeWeekdays() {
      return ALL_WEEKDAY_INDICES;
    },
    reset() {
      this.timeframe = deepCopyObject(defaults.timeframe);
      this.populateTimeframeWithDefaultValues();
    },
    onAborted() {
      this.$emit('update:show', false);
      this.$emit('aborted');
    },
    onConfirmed() {
      this.$emit('update:show', false);
      this.$emit('created', this.timeframe);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/CreateTimeframeDialog.vue